
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.244 0h.78c.902.252 1.501.917 2.131 1.548 5.03 5.037 10.065 10.07 15.099 15.102.15.15.3.298.437.458.877 1.018.862 2.345-.086 3.295a9411.106 9411.106 0 01-16.203 16.203c-.992.99-2.397.963-3.395-.021a685.28 685.28 0 01-2.943-2.917c-4.172-4.17-8.341-8.344-12.516-12.512-.632-.63-1.296-1.23-1.548-2.132v-.78c.291-.476.505-1.031.887-1.417 3.52-3.561 7.07-7.095 10.612-10.635.121-.12.255-.23.374-.338.087.054.134.074.168.107 1.278 1.273 2.56 2.544 3.821 3.835.11.111.138.377.098.548-.297 1.281.17 2.53 1.285 3.202.319.192.394.397.392.738-.011 3.024-.013 6.048 0 9.072.003.406-.081.664-.462.897-1.084.664-1.542 1.963-1.2 3.186.343 1.22 1.453 2.072 2.74 2.109 1.21.032 2.353-.764 2.775-1.932.423-1.175.041-2.524-.981-3.258-.32-.23-.432-.46-.43-.838.013-2.96.006-5.918.009-8.877 0-.156.014-.31.025-.498.09.042.139.051.168.08 1.13 1.125 2.264 2.244 3.372 3.387.107.11.104.381.068.56-.212 1.07.015 2.01.806 2.767.8.767 1.755 1.023 2.831.711 1.46-.421 2.354-1.97 2.005-3.44-.358-1.506-1.858-2.48-3.37-2.167-.31.064-.511-.018-.728-.237a157.361 157.361 0 00-3.28-3.273c-.353-.339-.527-.651-.348-1.135.062-.172.035-.387.011-.579-.234-1.955-2.1-2.924-3.483-2.566a.669.669 0 01-.545-.146c-1.257-1.226-2.488-2.478-3.74-3.711-.225-.223-.234-.37-.001-.593.69-.666 1.358-1.355 2.039-2.03.697-.692 1.318-1.487 2.326-1.773z","fill":"#fff"}})])
          )
        }
      }
    